export default {
  // FORM INPUT ACTIONS
  VALID_INPUT: 'VALID_INPUT',
  INVALID_INPUT: 'INVALID_INPUT',
  RESET_INPUT: 'RESET_INPUT',
  RESET_ERROR: 'RESET_ERROR',

  // MODAL ACTIONS
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',

  // ORDER DETAILS ACTIONS
  FETCH_ORDER_DETAILS: 'FETCH_ORDER_DETAILS',
  FETCH_ORDER_DETAILS_SUCCESS: 'FETCH_ORDER_DETAILS_SUCCESS',
  FETCH_ORDER_DETAILS_FAILURE: 'FETCH_ORDER_DETAILS_FAILURE',
  FETCH_ORDER_DETAILS_EMAIL_FAILURE: 'FETCH_ORDER_DETAILS_EMAIL_FAILURE',

  // ORDER HISTORY ACTIONS
  FETCH_ORDER_HISTORY: 'FETCH_ORDER_HISTORY',
  FETCH_ORDER_HISTORY_SUCCESS: 'FETCH_ORDER_HISTORY_SUCCESS',
  FETCH_ORDER_HISTORY_FAILURE: 'FETCH_ORDER_HISTORY_FAILURE',
  FETCH_ORDER_HISTORY_ORDER_DETAILS_SUCCESS:
    'FETCH_ORDER_HISTORY_ORDER_DETAILS_SUCCESS',
  FETCH_ORDER_HISTORY_ORDER_META: 'FETCH_ORDER_HISTORY_ORDER_META',
  FETCH_ORDER_HISTORY_ORDER_META_SUCCESS:
    'FETCH_ORDER_HISTORY_ORDER_META_SUCCESS',
  FETCH_ORDER_HISTORY_ORDER_META_ERROR: 'FETCH_ORDER_HISTORY_ORDER_META_ERROR',
  ORDER_HISTORY_DROPDOWN_SELECTION: 'ORDER_HISTORY_DROPDOWN_SELECTION',
  ORDER_HISTORY_PAGE_SELECTION: 'ORDER_HISTORY_PAGE_SELECTION',
  ORDER_HISTORY_DETAIL_TOGGLE: 'ORDER_HISTORY_DETAIL_TOGGLE',

  // ERECEIPTS ACTIONS
  ERECEIPTS_DETAILS_TOGGLE: 'ERECEIPTS_DETAILS_TOGGLE',
  FETCH_ERECEIPTS_SUMMARY: 'FETCH_ERECEIPTS_SUMMARY',
  FETCH_ERECEIPTS_SUMMARY_SUCCESS: 'FETCH_ERECEIPTS_SUMMARY_SUCCESS',
  FETCH_ERECEIPTS_SUMMARY_FAILURE: 'FETCH_ERECEIPTS_SUMMARY_FAILURE',
  FETCH_ERECEIPTS_DETAILS: 'FETCH_ERECEIPTS_DETAILS',
  FETCH_ERECEIPTS_DETAILS_SUCCESS: 'FETCH_ERECEIPTS_DETAILS_SUCCESS',
  FETCH_ERECEIPTS_DETAILS_FAILURE: 'FETCH_ERECEIPTS_DETAILS_FAILURE',
  ERECEIPTS_DROPDOWN_SELECTION: 'ERECEIPTS_DROPDOWN_SELECTION',
  ERECEIPTS_PAGE_SELECTION: 'ERECEIPTS_PAGE_SELECTION',

  // SHIPMENT TRACKING ACTIONS
  FETCH_SHIPMENT_TRACKING_DETAIL: 'FETCH_SHIPMENT_TRACKING_DETAIL',
  FETCH_SHIPMENT_TRACKING_DETAIL_SUCCESS:
    'FETCH_SHIPMENT_TRACKING_DETAIL_SUCCESS',
  FETCH_SHIPMENT_TRACKING_DETAIL_FAILURE:
    'FETCH_SHIPMENT_TRACKING_DETAIL_FAILURE',

  // BODFS DELIVERY DETAILS ACTIONS
  FETCH_BODFS_DELIVERY_DETAIL: 'FETCH_BODFS_DELIVERY_DETAIL',
  FETCH_BODFS_DELIVERY_DETAIL_SUCCESS: 'FETCH_BODFS_DELIVERY_DETAIL_SUCCESS',
  SHOW_EARLY_BODFS_TYT_MODAL: 'SHOW_EARLY_BODFS_TYT_MODAL',

  // ONLINE CANCEL ACTIONS
  ONLINE_CANCEL_INIT: 'ONLINE_CANCEL_INIT',
  ONLINE_CANCEL_RESET: 'ONLINE_CANCEL_RESET',
  CANCEL_ITEMS_SELECT: 'CANCEL_ITEMS_SELECT',
  CANCEL_ITEMS_REQUEST: 'CANCEL_ITEMS_REQUEST',
  CANCEL_ITEMS_SUCCESS: 'CANCEL_ITEMS_SUCCESS',
  CANCEL_ITEMS_FAILURE: 'CANCEL_ITEMS_FAILURE',
  BOPIS_CANCEL_SUCCESS: 'BOPIS_CANCEL_SUCCESS',
  OPEN_BOPIS_CANCEL_MODAL: 'OPEN_BOPIS_CANCEL_MODAL',
  CLOSE_BOPIS_CANCEL_MODAL: 'CLOSE_BOPIS_CANCEL_MODAL',

  // SELF SERVICE RETURNS ACTIONS
  FETCH_RETURN_REQUEST: 'FETCH_RETURN_REQUEST',

  // APPLIANCE ACTIONS
  CHANGE_APPLIANCE_CALENDAR_MONTH: 'CHANGE_APPLIANCE_CALENDAR_MONTH',
  FETCH_AVAILABLE_DELIVERY_SLOTS: 'FETCH_AVAILABLE_DELIVERY_SLOTS',
  FETCH_AVAILABLE_DELIVERY_SLOTS_FAILURE:
    'FETCH_AVAILABLE_DELIVERY_SLOTS_FAILURE',
  FETCH_AVAILABLE_DELIVERY_SLOTS_SUCCESS:
    'FETCH_AVAILABLE_DELIVERY_SLOTS_SUCCESS',
  FETCH_MA_CANCEL_ELIGIBILITY: 'FETCH_MA_CANCEL_ELIGIBILITY',
  FETCH_MA_CANCEL_ELIGIBILITY_FAILURE: 'FETCH_MA_CANCEL_ELIGIBILITY_FAILURE',
  FETCH_MA_CANCEL_ELIGIBILITY_SUCCESS: 'FETCH_MA_CANCEL_ELIGIBILITY_SUCCESS',
  MA_CANCEL_REQUEST: 'MA_CANCEL_REQUEST',
  MA_CANCEL_REQUEST_FAILURE: 'MA_CANCEL_REQUEST_FAILURE',
  MA_CANCEL_REQUEST_SUCCESS: 'MA_CANCEL_REQUEST_SUCCESS',
  RESET_APPLIANCE_CALENDAR: 'RESET_APPLIANCE_CALENDAR',
  SELECT_APPLIANCE_DELIVERY_DATE: 'SELECT_APPLIANCE_DELIVERY_DATE',
  SUBMIT_APPLIANCE_RESCHEDULE: 'SUBMIT_APPLIANCE_RESCHEDULE',
  SUBMIT_APPLIANCE_RESCHEDULE_FAILURE: 'SUBMIT_APPLIANCE_RESCHEDULE_FAILURE',
  SUBMIT_APPLIANCE_RESCHEDULE_SUCCESS: 'SUBMIT_APPLIANCE_RESCHEDULE_SUCCESS'
};
